import React from "react";
import { announcements } from "../mock";

export default function AnnouncementBar() {
  const loop = [...announcements, ...announcements];
  return (
    <div className="bg-sky text-navy overflow-hidden border-b border-navy/10">
      <div className="relative flex whitespace-nowrap">
        <div className="flex animate-marquee py-2">
          {loop.map((a, i) => (
            <span
              key={i}
              className="mx-8 text-[13px] font-semibold tracking-wide flex items-center gap-2"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-brand" />
              {a}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
